import { render, staticRenderFns } from "./HseMonitoring.vue?vue&type=template&id=240e2d1a&scoped=true&"
import script from "./HseMonitoring.vue?vue&type=script&lang=js&"
export * from "./HseMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./HseMonitoring.vue?vue&type=style&index=0&id=240e2d1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e2d1a",
  null
  
)

export default component.exports